<template>
  <div>
    <el-row class="stuff-main">
      <el-carousel
        height="476px"
        indicator-position="none"
        :autoplay="true"
        type="card"
        @change="changePic"
      >
        <el-carousel-item v-for="(item,index) in carouselList" :key="index">
          <img style="width: 100%; height: 450px;" :src="item.pic">
          <!-- <div class="changeText" v-show="index === picIndex">{{item.name}}</div> -->
        </el-carousel-item>
      </el-carousel>

      <div style="width: 200px; margin: 0 auto; text-align: center; font-weight: 700; font-size: 18px; margin-top: 15px;">{{imgTitle}}</div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      picIndex: 0,
      carouselList: [
        {
          pic: '../../static/img/contact/l_picture_01.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_02.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_03.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_04.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_05.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_06.jpg',
          name: ''
        },
        {
          pic: '../../static/img/contact/l_picture_07.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_08.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_09.jpg',
          name: '团建'
        },
        {
          pic: '../../static/img/contact/l_picture_10.jpg',
          name: '团建'
        }
      ]
    }
  },
  methods: {
    changePic(e) {
      const vm = this
      console.log(e)
      vm.picIndex = e
    }
  }
}
</script>

<style lang="scss" scoped>
.stuff-main {
  padding: 40px 18.75% 46px 18.75%;
}
.changeText {
  // color: blue;
  text-align: center;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/website/contact/component/stuff.vue